import { createSlice } from "@reduxjs/toolkit";

export const dealCouponCodeSlice = createSlice({
  name: "deal-coupon-code",
  initialState: {
    isLoading: false,
    isError: false,
    dealCouponCodeData: [],
    message: "",
    isPostLoading: false,
    postDealCouponCodeData: null,
    postDealCouponPinData: null,
    postDealCouponGCIDData: null,
    postDealCouponRefNoData: null,
    postMessage: "",
    post_status_code: null,
  },
  reducers: {
    onGetDealCouponCode: (state) => {
      return {
        ...state,
        isgetLoading: true,
        getDealCouponCodeData: [],
        getmessage: "",
      };
    },

    onGetDealCouponCodeSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isgetLoading: false,
        getDealCouponCodeData: data,
        getmessage: message,
        get_status_code: status_code,
      };
    },

    onGetDealCouponCodeError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        getDealCouponCodeData: data,
        getmessage: message,
        get_status_code: status_code,
        isgetLoading: false,
      };
    },
    onPostDealCouponCode: (state) => {
      return {
        ...state,
        isPostLoading: true,
        postDealCouponCodeData: null,
        postDealCouponPinData: null,
        postDealCouponGCIDData: null,
        postDealCouponRefNoData: null,
      };
    },

    onPostDealCouponCodeSuccess: (state, { payload }) => {
      const { postData = [], message = "", status_code = "200" } = payload;
      return {
        ...state,
        isPostLoading: false,
        postDealCouponCodeData: postData?.coupounCode || null,
        postDealCouponPinData: postData?.pin || null,
        postDealCouponGCIDData: postData?.gcid || null,
        postDealCouponRefNoData: postData?.referenceNo || null,
        postMessage: message,
        post_status_code: status_code,
      };
    },

    onPostDealCouponCodeError: (state, { payload }) => {
      const { postData = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        postDealCouponCodeData: postData?.coupounCode || null,
        postDealCouponPinData: postData?.pin || null,
        postDealCouponGCIDData: postData?.gcid || null,
        postDealCouponRefNoData: postData?.referenceNo || null, 
        postMessage: message,
        post_status_code: status_code,
        isPostLoading: false,
      };
    },
    onPostDealCouponCodeReset: (state) => {
      return {
        ...state,
        postMessage: "",
        post_status_code: null,
      };
    },
    onPostDealCodeReset: (state) => {
      return {
        ...state,
        postMessage: "",
        postDealCouponCodeData: null,
        postDealCouponPinData: null,
        postDealCouponGCIDData: null,
        postDealCouponRefNoData: null,
        post_status_code: null,
      };
    },
    onGetDealCouponCodeReset: (state) => {
      return {
        ...state,
        get_status_code: [],
      };
    },
  },
});

export const {
  onGetDealCouponCode,
  onGetDealCouponCodeSuccess,
  onGetDealCouponCodeError,
  onPostDealCouponCode,
  onPostDealCouponCodeSuccess,
  onPostDealCouponCodeError,
  onPostDealCouponCodeReset,
  onGetDealCouponCodeReset,onPostDealCodeReset
} = dealCouponCodeSlice.actions;

export default dealCouponCodeSlice.reducer;
